import { JwtHelperService } from "@auth0/angular-jwt";
import { LocalRepository } from "@shared/helper/local-repository";
import { ACCESS_TOKEN_KEY } from "constants/storage-keys";

export const roleGuard = (
    repo: LocalRepository,
    jwtHelper: JwtHelperService,
    roleNames: string[],
    expectedResult: number,
): boolean => {

    let actualResult = 0;
    const TOKEN = repo.getCookieItem(ACCESS_TOKEN_KEY);

    if (TOKEN) {
        const DECODED_TOKEN = jwtHelper.decodeToken(TOKEN);
        if (DECODED_TOKEN.role) {
            const ROLES = (typeof DECODED_TOKEN.role === 'string') ? [DECODED_TOKEN.role] : DECODED_TOKEN.role;
            for (const role of ROLES) {
                if (roleNames.includes(role.toLowerCase())) {
                    actualResult++;
                }
            }
        }
    }

    const result = actualResult === expectedResult && actualResult > 0;
    if (!result) {
        console.error("Access denied. Insufficient roles.");
    }
    return result;
}

// role === 'author' ? this.userIsAuthor = true : false;
// role === 'librarian' ? this.userIsLibrarian = true : false;
// role === 'publisher' ? this.userIsPublisher = true : false;
// role === 'blogger' ? this.userIsBlogger = true : false;